function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import TechnicalUploadsForm from '@rd-web-markets/shared/dist/claim_group/technical_uploads/TechnicalUploadsForm';
import documentsService from '@services/claim_project_reports/documents_service';
import { Table } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
const ProjectDocumentsSection = _ref => {
  let {
    isImmutableUnderReview,
    report,
    handleToaster,
    setReport
  } = _ref;
  const [uploads, setUploads] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const fetchUploads = useErrorHandling(useCallback(async () => {
    const uploads = await documentsService.all(report.id);
    setUploads(uploads);
    setReport(_objectSpread(_objectSpread({}, report), {}, {
      additional_documentations: uploads
    }));
  }, [report.id]));
  const handleSubmit = useErrorHandling(useCallback(async (document, file) => {
    if (!file) {
      handleToaster('Attach a file before submitting', 'warning');
    } else {
      setLoading(true);
      let fd = new FormData();
      fd.append('file', file);
      fd.append('additional_documentation', JSON.stringify(document));
      await documentsService.create(report.id, fd);
      await fetchUploads();
      setLoading(false);
    }
  }, [report.id]), () => {
    setLoading(false);
  });
  const handleDelete = useErrorHandling(useCallback(async uploadId => {
    if (window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_FILE_CONFIRMATION_MESSAGE)))) {
      setLoading(true);
      await documentsService.delete(report.id, uploadId);
      fetchUploads();
      setLoading(false);
    }
  }, [report.id, t]));
  const rows = upload => {
    var _upload$document, _upload$document2;
    return {
      key: upload.id,
      columns: [/*#__PURE__*/React.createElement("a", {
        rel: "noreferrer",
        href: upload === null || upload === void 0 || (_upload$document = upload.document) === null || _upload$document === void 0 ? void 0 : _upload$document.url,
        target: "_blank"
      }, /*#__PURE__*/React.createElement("small", null, upload === null || upload === void 0 || (_upload$document2 = upload.document) === null || _upload$document2 === void 0 ? void 0 : _upload$document2.filename)), upload.comments, upload.uploaded_by, createTimezonedDate(new Date(upload.created_at)).toCustomLocaleDateString()],
      onDelete: () => handleDelete(upload.id)
    };
  };
  const headers = useMemo(() => [{
    text: t('document_name')
  }, {
    text: t('document_comments')
  }, {
    text: t('uploaded_by')
  }, {
    text: t('date')
  }, {
    text: ''
  }], [t]);
  const tableRows = (report.additional_documentations || []).map(rows);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-4"
  }, t('upload_document')), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(TechnicalUploadsForm, {
    isImmutableUnderReview: isImmutableUnderReview,
    handleSubmit: handleSubmit,
    loading: loading,
    showDocumentType: false
  }), /*#__PURE__*/React.createElement(Table, {
    isImmutableUnderReview: isImmutableUnderReview,
    headers: headers,
    rows: tableRows,
    onDelete: (index, row) => handleDelete(row.key)
  }))));
};
export default ProjectDocumentsSection;